import { Chart } from "chart.js";
import { Bar } from 'react-chartjs-2';
import { CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

const BandGraph2 = ({ data }) => {
    // ローディングを待っている時は'読み込み中...'、データがない時は'データが登録されていません'を表示
    if (!data || !data.scale || !data.process || !data.term) {
        return <div>{!data ? '読み込み中...' : 'データが登録されていません'}</div>;
    }

    // 色の配列を定義
    const colors = ['#0A2B5F', '#95D2E5', '#C9D2D6'];

    const getFilteredDatasets = (categoryData) => {
        return Object.entries(categoryData)
            .map(([key, obj], index) => ({
                label: key,
                data: [obj.value || 0, 0, 0],
                period: obj.period || '',
                backgroundColor: colors[index % colors.length],
                borderWidth: 0,
            }));
    };

    const scaleDatasets = getFilteredDatasets(data.scale);
    const processDatasets = getFilteredDatasets(data.process);
    const termDatasets = getFilteredDatasets(data.term);

    const FONT_SIZE = 12;

    const config = {
        options: {
            maintainAspectRatio: false,
        },
        type: 'bar',
        data: {
            labels: ['規模', '担当工程', 'PJ期間'],
            datasets: [
                ...scaleDatasets.map((dataset) => ({
                    ...dataset,
                    data: [dataset.data[0], 0, 0],
                })),
                ...processDatasets.map((dataset) => ({
                    ...dataset,
                    data: [0, dataset.data[0], 0],
                })),
                ...termDatasets.map((dataset) => ({
                    ...dataset,
                    data: [0, 0, dataset.data[0]],
                })),
            ]
        },
        options: {
            indexAxis: 'y',
            elements: {
                bar: {
                    borderWidth: 2,
                }
            },
            responsive: true,
            plugins: {
                legend: {
                    display: false,
                },
                datalabels: {
                    display: true,
                    color: '#fff',
                    font: {
                        weight: 'bold',
                        size: FONT_SIZE
                    },
                    formatter: function(value, context) {
                        if (value > 0) {
                            // valueが10%以下の場合は「...」を表示
                            if (value <= 10) {
                                return '...';
                            }
                            const label = context.dataset.label;
                            const chart = context.chart;
                            const meta = chart.getDatasetMeta(context.datasetIndex);
                            const bar = meta.data[context.dataIndex];
                            // 幅が取得できない場合は仮の幅を使う
                            let barWidth = (bar && (bar.width || (bar._view && bar._view.width))) || 80;
                            const fontSize = FONT_SIZE;
                            const ctx = chart.ctx;
                            ctx.font = `bold ${fontSize}px sans-serif`;
                            // ラベル改行
                            let lines = [];
                            let currentLine = '';
                            for (let i = 0; i < label.length; i++) {
                                const testLine = currentLine + label[i];
                                const { width } = ctx.measureText(testLine);
                                if (width > barWidth && currentLine !== '') {
                                    lines.push(currentLine);
                                    currentLine = label[i];
                                } else {
                                    currentLine = testLine;
                                }
                            }
                            if (currentLine) lines.push(currentLine);
                            return lines;
                        }
                        return '';
                    }
                },
                tooltip: {
                    callbacks: {
                        title: function(context) {
                            return '';
                        },
                        label: function(context) {
                            // ラベル名: 期間（ex 開発: 1年3か月）
                            const labelName = context.dataset.label;
                            const period = context.dataset.period || '';
                            return `${labelName}: ${period}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    stacked: true,
                    max: 100,
                    ticks: {
                        stepSize: 10,
                        callback: function(value) {
                            return value + '%';
                        }
                    }
                },
                y: {
                    stacked: true,
                }
            },
            layout: {
                padding: {
                    left: 0,
                    right: 0,
                    top: 10,
                    bottom: 10
                }
            }
        },
        plugins: [ChartDataLabels],
    };

    return <Bar {...config} />;
};

export default BandGraph2;
